import React, {Component} from "react";
import {SelectInput} from "../../../../../../components";
import RemotingService from "../../../../../../services/remoting-service/RemotingService";
import MedicalTourismPayerTypeEnum from "../../../../enums/MedicalTourismPayerTypeEnum";
import {Button, Col, Container, Row} from "react-bootstrap";


export default class PayerTypeSelectionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPayerType: null
        };
    }

    savePayerType = () => {
        if (!this.state.selectedPayerType) {
            return;
        }

        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/claims/claim/${this.props.claimId}/medical-tourism-payer-type`,
            {medicalTourismPayerType: this.state.selectedPayerType},
            () => {
                if (this.props.onSaved) {
                    this.props.onSaved();
                }
                if (this.props.close) {
                    this.props.close();
                }
            }
        );
    }

    render() {
        return (
            <Container style={{width: 400, padding: "20px"}}>
                <Row className="mb-3">
                    <Col>
                        <label className="font-weight-bold">Select Medical Tourism Payer Type</label>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <SelectInput searchEnabled={false}
                                     displayProperty="name"
                                     valueProperty="key"
                                     options={MedicalTourismPayerTypeEnum.toArray()}
                                     value={this.state.selectedPayerType}
                                     onChange={(value) => this.setState({selectedPayerType: value})}/>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right">
                        <Button variant="success"
                                disabled={!this.state.selectedPayerType}
                                onClick={this.savePayerType}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}
